import { formatTime, formatTimestampToUTC } from "../formatTime";


const profileLink = user => `[@${user}](https://peakd.com/@${user})`;


export const prepVictoryMsgDiscord = ({
  matchTracker, fen,
  whiteTime, blackTime,
  isDraw, isTimeout, opponentDisconnected,
}) => {
  const { approxStartTime, matchInfo, moves } = matchTracker;
  const { localPlayer: winnerName, localPlayerColor: winnerColor, opponent } = matchInfo;

  // BOARD IMAGE
  const encodedFen = encodeURIComponent(fen);
  // TODO: replace with programmatically generated screen screenshot??
  const board = `https://fen2image.chessvision.ai/${encodedFen}.png`;
  
  // UI PARTS
  // winner
  const winnerTxt = `${profileLink(winnerName)} (${winnerColor})`;
  // result
  const matchResult = isDraw ? '__**drew**__ with' : `__**WON**__${
    opponentDisconnected ? ' by opponent abandonment' : ''
  }${isTimeout ? ' by timeout' : ''}`;
  // opponent
  const opponentTxt = `against ${profileLink(opponent)}!`;
  // reaction
  const reaction = isDraw ? '' : ' 😎 ♟️';
  // time
  const gameStart = formatTimestampToUTC({ ts: approxStartTime });
  const timeInfo = `Started at ${gameStart} UTC. Time left: w ${
    formatTime(whiteTime)}, b ${formatTime(blackTime)}`;
  // moves
  const matchMoves = moves.length ? `\t[moves](https://crypto-chess.com?moves=${moves.join(',')})` : '';
  
  // Result
  const msg = `${winnerTxt} ${matchResult} ${opponentTxt} ${reaction}\n${timeInfo}${matchMoves}`;
  return ({ msg, board });
};
